import { render, staticRenderFns } from "./GerarPepArquvios.vue?vue&type=template&id=66221694&"
import script from "./GerarPepArquvios.vue?vue&type=script&lang=js&"
export * from "./GerarPepArquvios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports